import {
  IsWithdrawalAllowedQuery,
  IsWithdrawalAllowedQueryVariables,
  UseIsWithdrawalAllowedProps,
} from "@ctypes";
import { IS_WITHDRAWAL_ALLOWED } from "@graphql";
import { useQuery } from "@hooks/apollo";

export const useIsWithdrawalAllowed = ({ goalId, subaccountId }: UseIsWithdrawalAllowedProps) => {
  const { data: queryData, ...rest } = useQuery<
    IsWithdrawalAllowedQuery,
    IsWithdrawalAllowedQueryVariables
  >(IS_WITHDRAWAL_ALLOWED, {
    variables: { goalId, subaccountId },
  });

  const data = queryData?.isWithdrawalAllowed;

  return { data, ...rest };
};
